/* Fann Bliss: product spotlight sections (sections/fann-spotlight.liquid).
   Lid tour tabs (arrow keys, Home/End) whose little scenes play when a tab opens, the stage rising in when it scrolls
   in, the design row arrows, and the quantity ladder that reads the bag and lights the price the shopper has reached.
   No dependencies. */
(function () {
  'use strict';
  if (window.__fhSpot) return; window.__fhSpot = 1;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && Shopify.designMode);
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* replay a panel's scene: drop the class, force a style flush, add it back */
  function play(panel) {
    if (!panel) return;
    panel.classList.remove('fh-play'); void panel.offsetWidth; panel.classList.add('fh-play');
  }

  function tabs(root) {
    var list = root.querySelector('[role="tablist"]');
    if (!list || list.__fh) return; list.__fh = 1;
    var btns = $$('[role="tab"]', list);
    var seen = false;
    function pick(i, focus) {
      btns.forEach(function (b, j) {
        var on = i === j, panel = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (panel) {
          panel.hidden = !on;
          if (on && seen) play(panel); else if (!on) panel.classList.remove('fh-play');
        }
      });
      if (focus) btns[i].focus();
    }
    /* the first scene plays once the tour is on screen */
    function first() {
      seen = true;
      var on = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || btns[0];
      if (on) play(document.getElementById(on.getAttribute('aria-controls')));
    }
    if (reduce || design || !('IntersectionObserver' in window)) first();
    else {
      root.classList.add('fh-will');
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { first(); io.disconnect(); } }, { threshold: 0.35 });
      io.observe(root.querySelector('.fh-spot-shot') || root);
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { seen = true; pick(i, false); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = btns.length, to = -1;
        if (k === 'ArrowRight') to = (i + 1) % n; else if (k === 'ArrowLeft') to = (i - 1 + n) % n; else if (k === 'Home') to = 0; else if (k === 'End') to = n - 1;
        if (to > -1) { e.preventDefault(); seen = true; pick(to, true); }
      });
    });
  }

  /* panels after the first are hidden, so their lazy pictures would only start loading on tap: fetch them once the
     tour comes near the screen */
  function warm(root) {
    var imgs = $$('.fh-spot-panel img', root);
    function go() { imgs.forEach(function (i) { i.loading = 'eager'; }); }
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { go(); io.disconnect(); } }, { rootMargin: '600px 0px' });
    io.observe(root);
  }

  function stage(sec) {
    var st = sec.querySelector('[data-fh-spot-stage]');
    if (!st || st.__fh) return; st.__fh = 1;
    if (reduce || design || !('IntersectionObserver' in window)) { st.classList.add('fh-is-in'); return; }
    st.classList.add('fh-will');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { st.classList.add('fh-is-in'); io.disconnect(); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });
    io.observe(st);
  }

  /* the design row: arrows page through it, the progress line follows the scroll, and on touch screens the row
     slides a little the first time it comes into view so it reads as swipeable */
  function rail(sec) {
    var r = sec.querySelector('[data-fh-spot-rail]');
    if (!r || r.__fh) return; r.__fh = 1;
    var shelf = sec.querySelector('[data-fh-spot-shelf]') || sec;
    var prev = shelf.querySelector('[data-fh-spot-prev]'), next = shelf.querySelector('[data-fh-spot-next]');
    var thumb = shelf.querySelector('[data-fh-spot-thumb]');
    function stepW() {
      var c = r.querySelector('.fh-spot-card'); if (!c) return 160;
      var gap = parseFloat(getComputedStyle(r).columnGap) || 10;
      return c.getBoundingClientRect().width + gap;
    }
    function page() { var s = stepW(); return Math.max(s, Math.floor((r.clientWidth - 20) / s) * s); }
    function sync() {
      var max = r.scrollWidth - r.clientWidth, x = r.scrollLeft;
      var atStart = x <= 2, atEnd = x >= max - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      r.classList.toggle('fh-at-start', atStart);
      r.classList.toggle('fh-at-end', atEnd);
      shelf.classList.toggle('fh-no-scroll', max <= 2);
      if (thumb) {
        var w = max > 2 ? Math.max(.12, r.clientWidth / r.scrollWidth) : 1;
        thumb.style.setProperty('--w', w.toFixed(4));
        thumb.style.setProperty('--p', max > 2 ? Math.min(1, Math.max(0, x / max)).toFixed(4) : '0');
      }
    }
    function go(dir) { r.scrollBy({ left: dir * page(), behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var ticking = false;
    r.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    var touch = window.matchMedia && matchMedia('(hover: none)').matches;
    if (touch && !reduce && !design && 'IntersectionObserver' in window) {
      var stop = function () { shelf.classList.remove('fh-nudge'); };
      r.addEventListener('touchstart', stop, { passive: true });
      var io = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        if (r.scrollLeft > 2 || r.scrollWidth - r.clientWidth < 40) return;
        shelf.classList.add('fh-nudge');
        setTimeout(stop, 1600);
      }, { threshold: 0.6 });
      io.observe(r);
    }
  }

  /* ---- the quantity ladder: count the bag's pieces of this line and light the reached price ---- */
  var cartP = null;
  function getCart(fresh) {
    if (!cartP || fresh) {
      var url = (window.FannHome && FannHome.config && FannHome.config.routes && FannHome.config.routes.cartGet) || '/cart.js';
      cartP = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    return cartP;
  }
  function fill(t, n, sec) {
    return String(t || '').replace(/\[n\]/g, n).replace(/\[p2\]/g, sec.getAttribute('data-p2') || '').replace(/\[p3\]/g, sec.getAttribute('data-p3') || '');
  }
  function ladder(sec, cart) {
    var types = (sec.getAttribute('data-types') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var n = 0;
    if (cart && cart.items) cart.items.forEach(function (it) {
      if (it.properties && it.properties['_FB Service Item'] === 'true') return;
      if (types.indexOf(String(it.product_type || '').toLowerCase()) > -1) n += it.quantity;
    });
    var lvl = n >= 3 ? 3 : n === 2 ? 2 : 1;
    $$('.fh-spot-steps li', sec).forEach(function (li) { li.classList.toggle('fh-is-on', parseInt(li.getAttribute('data-min'), 10) === lvl); });
    var out = sec.querySelector('[data-fh-spot-nudge]');
    if (out) out.textContent = fill(sec.getAttribute(n >= 3 ? 'data-w-best' : n === 2 ? 'data-w-two' : n === 1 ? 'data-w-one' : 'data-w-zero'), n, sec);
    sec.classList.toggle('fh-has-bag', n > 0);
  }
  function ladders(fresh) {
    var secs = $$('[data-fh-spot]').filter(function (s) { return s.querySelector('.fh-spot-steps'); });
    if (!secs.length) return;
    getCart(fresh).then(function (cart) { secs.forEach(function (s) { ladder(s, cart); }); });
  }

  function init(scope) {
    $$('[data-fh-spot]', scope).forEach(function (sec) {
      var tour = sec.querySelector('[data-fh-spot-tour]');
      if (tour) { tabs(tour); warm(tour); }
      stage(sec); rail(sec);
    });
    ladders(false);
  }

  document.addEventListener('fann:cart:updated', function () { ladders(true); });
  document.addEventListener('cart:updated', function () { ladders(true); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
